//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.image_gallery;
//  -- Examples array selector --------



export const useImageGalleryForAdmin = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}